
export default {
  toYuanWithUnitAndPoint(amount) {
    return amount ? `${(amount / 1e2).toFixed(2)}元` : '0.00元'
  },
}
